import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { getCurrentWeekRange, getFileNameFromUrl, myAxios } from "src/components/common/functions";
import { fields } from "./WorkOrderFilterForm";
import { appendField } from "src/components/common/FilterFrame/FilterField";
import { saveAs } from "file-saver";
import { extraFields } from "./WorkOrders";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";

export async function scanLoader({ request, params }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    const url = new URL(request.url);
    const proc  = url.searchParams.get("proc") ?? "";
    const step  = url.searchParams.get("step") ?? "";
    const status = url.searchParams.get("status") ?? "";
    const formData = new FormData();
    formData.append("id", id ?? "");
    formData.append("proc", proc);
    formData.append("step", step);
    formData.append("status", status);
    await myAxios({ fileName: "workOrders/scan.php", formData });
    throw redirect("../..");
}

export async function workOrdersLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    const orderByParam = url.searchParams.get("orderBy");
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (orderByParam && !["deadlineASC", "deadlineDESC"].includes(orderByParam)) {
        url.searchParams.delete("orderBy");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const formData = new FormData();
    formData.append("page", String(page));
    formData.append("limit", String(limit));
    if(orderByParam) formData.append("orderBy", orderByParam);
    for (const field of fields) {
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({ fileName: "workOrders/readWorkOrders.php", formData });
    if(!res) throw redirect("..");
    return res.data;
}
export async function workOrderSettingsLoader() {
    const res = await myAxios({
        fileName: "workOrders/readSettings.php",
    });
    if (!res || !res.data) throw redirect("..");
    return res.data;
}
export async function workOrderSettingsAction({ request }: LoaderFunctionArgs) {
    const formData = await request.formData();
    const res = await myAxios({
        fileName: "workOrders/updateSettings.php",
        formData
    });
    if(!res) return;
}
export async function workOrderLoader({ params }: LoaderFunctionArgs) {
    const { id } = params;
    if (!id) {
    throw redirect(`/readWorkOrder`);
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "workOrders/readWorkOrder.php",
        formData
    });
    if (!res || !res.data) throw redirect("..");
    return res.data;
}
const urlMap = {"Add": "workOrders/createWorkOrder.php", "Edit": "workOrders/updateWorkOrder.php"};
export async function workOrderAction({
    request
}: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(formData.get("poInvalid")){
        window.alert("The PO number is duplicated.");
        return;
    }
    formData.delete("poInvalid");
    const action = formData.get("action") as keyof typeof urlMap;
    formData.delete("action");
    const url = urlMap[action];
    if(!url){
        window.alert("Invalid Keyword");
        return;
    }
    formData.set("techs", JSON.stringify(formData.getAll("techs")));
    const statusData = JSON.parse(formData.get("statusData") as string);
    if(formData.get("totalDuration")){
        statusData.totalDuration = formData.get("totalDuration");
        formData.delete("totalDuration");
    }else{
        delete statusData.totalDuration;
    }
    formData.set("statusData", JSON.stringify(statusData));
    const res = await myAxios({ fileName: url, formData, signal: controller.signal });
    if(!res) return;
    if(action === "Add"){
        return redirect(`/WorkOrders/${res.data.id}`);
    }
    return redirect("..");
}
export async function deleteWorkOrderAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const res = await myAxios({
        fileName: "workOrders/deleteWorkOrder.php",
        formData: formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}
export async function voidWorkOrderAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    await myAxios({
        fileName: "workOrders/voidWorkOrder.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}
export async function validatWorkOrderAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    await myAxios({
        fileName: "workOrders/validateWorkOrder.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}
export async function transitionWorkOrderStatusAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    await myAxios({
        fileName: "workOrders/transitionWorkOrderStatus.php",
        formData,
        signal: controller.signal
    });
    throw redirect("..");
}
export async function workOrderExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: `/workOrders/exportWorkOrders.php`,
        formData, 
        responseType: "blob", 
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "workOrders.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}
export async function tasksLoader({ request }: LoaderFunctionArgs){
    const url = new URL(request.url);
    const week = getCurrentWeekRange();
    const createdAtFrom = url.searchParams.get("createdAtFrom");
    const createdAtTo = url.searchParams.get("createdAtTo");
    const workOrderStatus = url.searchParams.get("workOrderStatus");
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
            if(!["createdAtFrom", "createdAtTo", "workOrderStatus"].includes(key)){
                url.searchParams.delete(key);
                shouldRedirect = true;
            }
        }
    if (!createdAtFrom) {
        url.searchParams.set("createdAtFrom", week.start);
        shouldRedirect = true;
    }
    if (!createdAtTo) {
        url.searchParams.set("createdAtTo", week.end);
        shouldRedirect = true;
    }
    if(workOrderStatus !== null && !["Queue", "Active", "Parked", "Reporting", "Report Assist", "Hold", "Ready for Pickup", "Completed"].includes(workOrderStatus)){
        url.searchParams.delete("workOrderStatus");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());

    const formData = new FormData();
    formData.append("createdAtFrom", createdAtFrom as string);
    formData.append("createdAtTo", createdAtTo as string);
    const res = await myAxios({ fileName: "workOrders/readTasks.php", formData });
    if(!res) throw redirect("..");
    return res.data;
}
export async function tasksAction() {
    return "revalidate";
}


export async function generateStatusPDF({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const res = await myAxios({ fileName: "/workOrders/generatePDF.php", formData });
    if(!res) return;
    const url = res.data;
    try{
        const response = await fetch(url);
        if(!response.ok) throw new Error("Failed to fetch file");
        saveAs(await response.blob(), getFileNameFromUrl(url)!);
    }catch(error){
        window.alert("Error downloading file:" + error);
    }finally{
        throw redirect("..");
    }
}

export async function generateScanPDF({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const res = await myAxios({ fileName: "/workOrders/generateScanPDF.php", formData });
    if(!res) return;
    const url = res.data;
    try{
        const response = await fetch(url);
        if(!response.ok) throw new Error("Failed to fetch file");
        saveAs(await response.blob(), getFileNameFromUrl(url)!);
    }catch(error){
        window.alert("Error downloading file:" + error);
    }finally{
        throw redirect("..");
    }
}

export async function generateReqPDF({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const res = await myAxios({ fileName: "/workOrders/generateReqPDF.php", formData });
    if(!res) return;
    const url = res.data;
    try{
        const response = await fetch(url);
        if(!response.ok) throw new Error("Failed to fetch file");
        saveAs(await response.blob(), getFileNameFromUrl(url)!);
    }catch(error){
        window.alert("Error downloading file:" + error);
    }finally{
        throw redirect("..");
    }
}
